import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { billingService } from '../services/billing';
import { hasActivePaidPlan } from '../services/planAccess';

/**
 * Admins pass through. Everyone else needs an active paid plan (any product).
 * Free and expired accounts are sent to pricing.
 */
const RequireActivePlan = ({ children }) => {
  const { user } = useAuth();
  const [allowed, setAllowed] = useState(user?.role === 'admin' ? true : null);

  useEffect(() => {
    if (user?.role === 'admin') {
      setAllowed(true);
      return undefined;
    }
    let mounted = true;
    billingService
      .getMyBilling()
      .then((data) => {
        if (mounted) setAllowed(hasActivePaidPlan(data?.plan));
      })
      .catch(() => {
        if (mounted) setAllowed(false);
      });
    return () => {
      mounted = false;
    };
  }, [user?.role]);

  if (allowed === null) {
    return (
      <div style={{ padding: 48, textAlign: 'center', color: '#4B5468' }}>
        Checking your plan…
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to="/pricing" replace />;
  }

  return children;
};

export default RequireActivePlan;
